import React, { useEffect, useState } from "react";
import "../Hero/CareerHero.css";
import careerImg from "../../../assets/images/career.png";

export default function CareerHero() {
  // default to public path; this avoids build-time missing-file errors
  const [bgImg, setBgImg] = useState("/design/careers-hero.png");

  useEffect(() => {
    const test = new Image();
    test.onload = () => setBgImg("/design/postule.png");
    test.onerror = () => {};
    test.src = "/design/postule.png";
  }, []);

  return (
    <section className="careers-hero" style={{ backgroundImage: `url(${bgImg})` }}>
      <div className="hero-overlay">
        <div className="hero-content container">
          <img src={careerImg} alt="Career" className="hero-image" />
        </div>
      </div>
    </section>
  );
}
